<template>
    <div :class="no_hide ? '' : 'd-none d-print-block'" class="mt-3">
        <div class="d-flex justify-content-center" v-if="posicao == 'C' && show_logo && logo_url">
            <img
                :src="logo_url"
                rel="preload"
                height="120mm"
            />
        </div>

        <table width="100%" v-if="posicao == 'E'">
            <tr>
                <td v-if="show_logo && logo_url && posicao == 'E'" width="1%">
                    <img
                        :src="logo_url"
                        rel="preload"
                        height="120mm"
                        class="mr-3"
                    />
                </td>
                <td v-if="!hide_campos">
                    <h4 v-if="!nome_empresa || nome_empresa != '.'">{{ empresa_usuario ? empresa_usuario : ( nome_empresa ? nome_empresa : $store.state.unidade.st_nome_fantasia ) }}</h4>

                    <template v-if="show_cnpj">
                        <div>CNPJ: {{ $util.formatMask($store.state.unidade.st_cnpj, 'cnpj') }}</div>
                        <div v-if="$store.state.unidade.endereco">{{ $store.state.unidade.endereco.exibir }}</div>
                    </template>

                    <h3>{{ titulo }}</h3>
                </td>
                <td v-if="show_logo && logo_url && ( posicao == 'D' || !posicao )" width="1%">
                    <img
                        :src="logo_url"
                        rel="preload"
                        height="120mm"
                        class="ml-3"
                    />
                </td>
            </tr>
        </table>

        <div v-else class="d-flex" :class="( hide_campos && posicao == 'D' ) 
            ? 'justify-content-end' 
            : ( ( hide_campos && posicao == 'C' ) ? 'justify-content-center' : 'justify-content-between' )">
            <div v-if="show_logo && logo_url && posicao == 'E'">
                <img
                    :src="logo_url"
                    rel="preload"
                    height="120mm"
                />
            </div>
            <div v-if="!hide_campos">
                <h4 v-if="!nome_empresa || nome_empresa != '.'">{{ nome_empresa ? nome_empresa : $store.state.unidade.st_nome_fantasia }}</h4>

                <template v-if="show_cnpj">
                    <div>CNPJ: {{ $util.formatMask($store.state.unidade.st_cnpj, 'cnpj') }}</div>
                    <div v-if="$store.state.unidade.endereco">{{ $store.state.unidade.endereco.exibir }}</div>
                </template>

                <h3>{{ titulo }}</h3>
            </div>
            <div v-if="show_logo && logo_url && ( posicao == 'D' || !posicao )">
                <img
                    :src="logo_url"
                    rel="preload"
                    height="120mm"
                />
            </div>
        </div>

        <div class="alert alert-secondary mb-3">
            <slot></slot>

            <div v-if="show_emissor" class="small text-muted">
                Emitido por: {{ $store.state.user.st_login }} em {{ $util.getFormatDate($util.hoje()) }} {{ $util.agora() }}
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: ['titulo', 'show_cnpj', 'show_logo', 'logo', 'nome_empresa', 'hide_campos', 'logo_posicao', 'no_hide', 'cabecalho', 'show_emissor'],

    computed: { 
        empresa_usuario: function () { 
            if ( this.$store.state.user && this.$store.state.user.id_unidade_operacao ) { 
                let unid = this.$util.unidade_operacao(); 

                return _.get(unid, 'st_nome');
            }

            return ''; 
        },

        logo_url: function () { 
            return this.logo ? this.logo : this.$store.state.logo;
        },

        posicao: function () { 
            if ( this.logo_posicao ) { 
                return this.logo_posicao;
            }

            if ( this.cabecalho && this.cabecalho.st_logo_posicao ) { 
                return this.cabecalho.st_logo_posicao;
            }

            return 'E';
        }
    }
}
</script>